import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { applyEditionTheme } from './editions';
import reportWebVitals from './reportWebVitals';

// Pose l'attribut d'édition et charge ses polices avant le premier rendu,
// pour qu'aucune image du site n'apparaisse avec l'habillage d'une autre année.
applyEditionTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
